<template>
    <div
        class="py-lg"
        :class="{ 'border-b border-neutral-lightest' : ! isLast }"
    >
        <checkbox-input
            v-model="isChecked"
            name="field_technicians[]"
            :value="user.id"
        >
            {{ user.name }}
        </checkbox-input>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
            isLast: {
                type: Boolean,
                required: true,
            },
            existingFieldTechnicianIds: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                isChecked: false,
            };
        },
        created() {
            if (this.existingFieldTechnicianIds.find((userId) => this.user.id === userId)) {
                this.isChecked = true;
            }
        },
    };
</script>
